<template>
  <div class="kay-data-table">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="row">
            <div class="col-md-12">
              <div class="card-header">
                <h4 class="card-title">{{ $t("SiUsers.Distributor_Account_Manager")}}</h4>
              </div>
              <div class="card-body">
                <!-- <router-link to="./gaa-users/new" type="success">
                  <n-button type="success">建立 GAA 管理員</n-button>
                </router-link>-->
                <!-- Delete DIALOG -->
                <el-dialog :visible.sync="dialogs.delete.show">
                  <div class="row justify-content-center">
                    <div align='center' v-if="!dialogs.delete.cancel" >
                      <i style="font-size: 100px; color:orange" class="el-icon-warning-outline"></i>
                      <h2>{{ $t("SiUsers.Message.Confirm_to_do_action")}}</h2>
                      <h4>{{ $t("SiUsers.Message.You_can_not_restore_this_account")}}</h4>
                      <span slot="footer" class="dialog-footer" align='center' >
                        <el-button type="success" @click="deleteSiUser">{{ $t("SiUsers.Message.Confirm_to_delete")}}</el-button>
                        <el-button type="danger" @click="dialogs.delete.cancel = true">{{ $t("SiUsers.Message.Reserve_the_account")}}</el-button>
                      </span>
                    </div>
                    <div align="center" v-if="dialogs.delete.cancel">
                      <i style="font-size: 100px; color:red" class="el-icon-circle-close"></i>
                      <h2>{{ $t("SiUsers.Message.Cancelled")}}</h2>
                      <h4>{{ $t("SiUsers.Message.You_account_wat_not_affected_in_any_way")}}</h4>
                      <span slot="footer" class="dialog-footer">
                        <el-button type="primary" @click="dialogs.delete.show = false;">OK</el-button>
                      </span>
                    </div>
                  </div>
                  
                </el-dialog>
                <!-- END Delete DIALOG -->

                <!-- Delete confrimation DIALOG -->
                <!--
                <el-dialog :visible.sync="dialogs.deleteConfirm.show">
                  <div class="row justify-content-center">
                    <div align="center">
                      <i style="font-size: 100px; color:red" class="el-icon-circle-close"></i>
                      <h2>已取消</h2>
                      <h4>您的商品沒有受到任何影響</h4>
                      <span slot="footer" class="dialog-footer">
                        <el-button type="primary" @click="dialogs.deleteConfirm.show = false">OK</el-button>
                      </span>
                    </div>
                  </div>
                </el-dialog>
                -->
                <!-- END Delete confrimation DIALOG -->

                <el-row :gutter="20">
                  <el-col :xs="24" :md="6">
                    <el-input
                      v-model="filters[0].value"
                      :placeholder="$t('SiUsers.Message.Search')"
                      prefix-icon="el-icon-search"
                    ></el-input>
                  </el-col>
                  <el-col :xs="24" :md="6">
                    <router-link to="./si-users/new" type="success">
                      <el-button type="success" round plain
                        >{{ `${$t("SiUsers.Create")}${$t("SiUsers.Distributor_Account_Manager")}`}}</el-button
                      >
                    </router-link>
                    <!-- <el-dropdown @command="handleClick">
                      <el-button type="primary">
                        Actions
                        <i class="el-icon-caret-bottom el-icon--right"></i>
                      </el-button>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="new">new</el-dropdown-item>
                        <el-dropdown-item command="import">import</el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>-->
                  </el-col>
                </el-row>

                <data-tables
                  :data="data"
                  :filters="filters"
                  :action-col="actionCol"
                >
                  <el-table-column
                    v-for="title in titles"
                    :prop="title.prop"
                    :label="title.label"
                    :key="title.prop"
                    sortable="custom"
                  ></el-table-column>
                </data-tables>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import moment from "moment";

export default {
  data() {
    return {
      data: [],
      filters: [
        {
          value: "",
          prop: ["id", "name", "email"]
        },
        {
          value: []
        }
      ],
      dialogs: {
        delete: {
          show: false,
          siUser: null,
          cancel: false
        }
      }
    };
  },
  computed: {
    titles() {
      return [
        {
          prop: "id",
          label: this.$t('SiUsers.Number'),
        },
        {
          prop: "email",
          label: this.$t('SiUsers.Email'),
        },
        {
          prop: "name",
          label: this.$t('SiUsers.Name'),
        },
        {
          prop: "createdAt",
          label: this.$t("SiUsers.Create_Time")
        },
        {
          prop: "updatedAt",
          label: this.$t("SiUsers.Update_Time")
        }
      ]
    },
    actionCol() {
      return {
        label: this.$t("EaaAccounts.Action"),
        props: {
          align: "center"
        },
        buttons: [
          {
            props: {
              type: "default",
              icon: "el-icon-edit"
            },
            label: this.$t("EaaAccounts.Update_Account_Password"),
            handler: row => this.defaultBtnHandler(row)
          },
          {
            props: {
              type: "danger",
              icon: "el-icon-delete"
            },
            label: "",
            handler: row => this.dangerBtnHandler(row)
          }, 
        ]
      }
    },
    user: function() {
      return this.$store.getters.user;
    },
    userType: function() {
      return this.$store.getters.user.type;
    }
  },
  methods: {
    defaultBtnHandler(row) {
      console.log("the row is ", row);

      this.$router.push(
        `/si-accounts/${
          this.user.type === "gaa"
            ? this.$route.params.siId
            : this.user.id
        }/si-users/${row.id}/edit`
      );
    },
    dangerBtnHandler(row) {
      console.log("the row is ", row);
      this.dialogs.delete.cancel = false; 
      this.dialogs.delete.show = true;
      this.dialogs.delete.siUser = row.id;
      // this.deleteSiUser(row.id);
    },
    handleClick(command) {
      this.$message(`click dropdown button ${command}`);
    },
    getSiUsers() {
      let siId = this.$route.params.siId || this.user.id;
      return axios
        .get(`${process.env.VUE_APP_APIHOST}/gaa/si-accounts/${siId}/si-users`)
        .then(response => {
          this.data = response.data;
          for (let a of this.data) {
            a.createdAt = moment
              .unix(a.createdTs)
              .format("YYYY-MM-DD HH:mm:ss Z");
            a.updatedAt = moment
              .unix(a.updatedTs)
              .format("YYYY-MM-DD HH:mm:ss Z");
          }
          return response.data;
        });
    },
    // deleteSiUser(siUserId) {
    deleteSiUser() {  
      let self = this;
      let siUserId = self.dialogs.delete.siUser;
      console.log('siUserId ' + siUserId);
      console.log('user ' + JSON.stringify(self.user));
      let siId = this.$route.params.siId || this.user.id;
      console.log('self type ' + self.userType);
      if (self.userType === "si") {
        return axios
          .delete(
            `${process.env.VUE_APP_APIHOST}/${
              self.userType
            }/si-users/${siUserId}`
          )
          .then(response => {
            console.log(response.data);
            this.dialogs.delete.cancel = false; 
            this.dialogs.delete.show = false;
            this.dialogs.delete.siUser = null;
            self.getSiUsers();
            return response.data;
          });
      } else if (self.userType === "gaa") {
          return axios
          .delete(
            `${process.env.VUE_APP_APIHOST}/${
              self.userType
            }/si-accounts/${siId}/si-users/${siUserId}`
          )
          .then(response => {
            console.log(response.data);
            this.dialogs.delete.cancel = false; 
            this.dialogs.delete.show = false;
            this.dialogs.delete.siUser = null;
            self.getSiUsers();
            return response.data;
          });
      }
    }
  },
  mounted() {
    this.getSiUsers();
  }
};
</script>
<style scoped>
.kay-data-table .btn-base,
.el-select .el-input .el-input__inner,
.btn,
.navbar .navbar-nav > a.btn {
  margin: 0px !important;
}
</style>
